import { useEffect } from "react";
import { useSelector } from "react-redux";
import { getSDG } from "../Application/SDG.business";
import {
  getSDGSelector,
  getSDGCountSelector,
} from "../Infrastructure/SDG.reducer";
import SDGBoard from "./SDGBoard";
import "./SDG.css";
import { CustomCard, Title } from "../../Utils/UI/Text";

const SDG = () => {
  const sdg = useSelector(getSDGSelector);
  const totalSDG = useSelector(getSDGCountSelector);

  useEffect(() => {
    getSDG();
  }, []);

  return (
    <>
      <Title children="Objetivos de Desarrollo Sostenible (SDG)" />

      <CustomCard>
        <SDGBoard sdg={sdg} getSDG={getSDG} totalSDG={totalSDG} />
      </CustomCard>
    </>
  );
};

export default SDG;
